// Application Components
import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { object, string } from 'yup'
import { useNavigate } from 'react-router-dom'
import { translateMultiFormField } from '../../functions/field-functions'
import { extractSubmissionsForm } from '../../functions/form-functions'

//// Application Slices
import { selectSettings } from '../../reducers/settingSlice'
import {
    updateSubFormValidity,
    updateFormSystem,
    selectForms,
} from '../../reducers/formSlice'

//// Application Components
import DividerComponent from '../../components/simple-components/divider-component'
import ButtonComponent from '../../components/conditional-components/button-component'
import LoadingComponent from '../../components/simple-components/loading-component'
import NotificationComponent from '../../components/conditional-components/notification-component'

// FLDOH Forms
import DisciplineHistoryDeniedForm from './discipline-history-denied-form'
import DisciplineHistoryDisciplinaryActionForm from './discipline-history-disciplinary-action-form'
import DisciplineHistorySurrenderedForm from './discipline-history-surrendered-form'
import DisciplineHistoryPendingForm from './discipline-history-pending-form'

//// Carbon Components
import { Form } from '@carbon/react'

//// Carbon Icons

//// Static Constants

//////// Component
const DisciplineHistoryForm = ({ instance }) => {
    //////// Hooks
    const dispatch = useDispatch()
    const navigate = useNavigate()

    //////// State
    const [loading, setLoading] = useState(false)
    const [notification, setNotification] = useState({})

    //////// Slices
    const settingsData = useSelector(selectSettings)
    const formsData = useSelector(selectForms)

    //// Slice Data
    const digital_name = settingsData?.['form']?.['digital_name']
    const submit_route = settingsData?.['form']?.['submit_route']
    const fields = settingsData?.['form']?.['fields']
    const max_form_iterations =
        settingsData?.['application']?.['max_form_iterations']
    const sub_forms = settingsData?.['form']?.['sub_forms']

    //////// Search Params

    //////// Methods

    // Generate Validation Schema
    const generateSchema = async (digital_sub_name, auxAddtForms) => {
        try {
            const dynamic = {}

            // Check For Form Preset Letter
            if (digital_sub_name === 'denied') {
                dynamic.form = 'A'
            } else if (digital_sub_name === 'action') {
                dynamic.form = 'B'
            } else if (digital_sub_name === 'surrendered') {
                dynamic.form = 'C'
            } else if (digital_sub_name === 'pending') {
                dynamic.form = 'D'
            }

            // Check For Additional Forms
            if (auxAddtForms?.length > 0) {
                dynamic.addtObjs = [
                    {
                        ['RSD34' + dynamic?.form]: '',
                        ['STATE' + dynamic?.form]: '',
                        ['RSD36' + dynamic?.form]: '',
                        ['FIN_ACT' + dynamic?.form]: '',
                        ['RSD39' + dynamic?.form]: '',
                        ['LIC_NTS' + dynamic?.form]: '',
                    },
                ]
                dynamic.addtFilds = [
                    {
                        ['RSD34' + dynamic?.form]: '',
                        ['RSD34' + dynamic?.form + 'ErrMsg']: '',
                        ['STATE' + dynamic?.form]: '',
                        ['STATE' + dynamic?.form + 'ErrMsg']: '',
                        ['RSD36' + dynamic?.form]: '',
                        ['RSD36' + dynamic?.form + 'ErrMsg']: '',
                        ['FIN_ACT' + dynamic?.form]: '',
                        ['FIN_ACT' + dynamic?.form + 'ErrMsg']: '',
                        ['RSD39' + dynamic?.form]: '',
                        ['RSD39' + dynamic?.form + 'ErrMsg']: '',
                        ['LIC_NTS' + dynamic?.form]: '',
                        ['LIC_NTS' + dynamic?.form + 'ErrMsg']: '',
                    },
                ]
                dynamic.addtObjs[0] = {
                    ...dynamic.addtObjs[0],
                    ['RSD34' + dynamic?.form]: '',
                    ['STATE' + dynamic?.form]: '',
                    ['RSD36' + dynamic?.form]: '',
                    ['FIN_ACT' + dynamic?.form]: '',
                    ['RSD39' + dynamic?.form]: '',
                    ['LIC_NTS' + dynamic?.form]: '',
                }
                dynamic.addtFilds[0] = {
                    ...dynamic.addtFilds[0],
                    ['RSD34' + dynamic?.form]: '',
                    ['RSD34' + dynamic?.form + 'ErrMsg']: '',
                    ['STATE' + dynamic?.form]: '',
                    ['STATE' + dynamic?.form + 'ErrMsg']: '',
                    ['RSD36' + dynamic?.form]: '',
                    ['RSD36' + dynamic?.form + 'ErrMsg']: '',
                    ['FIN_ACT' + dynamic?.form]: '',
                    ['FIN_ACT' + dynamic?.form + 'ErrMsg']: '',
                    ['RSD39' + dynamic?.form]: '',
                    ['RSD39' + dynamic?.form + 'ErrMsg']: '',
                    ['LIC_NTS' + dynamic?.form]: '',
                    ['LIC_NTS' + dynamic?.form + 'ErrMsg']: '',
                }

                auxAddtForms.forEach((el) => {
                    dynamic.addtObjs.push({
                        [`RSD34` + dynamic?.form + el]: '',
                        [`STATE` + dynamic?.form + el]: '',
                        [`RSD36` + dynamic?.form + el]: '',
                        [`FIN_ACT` + dynamic?.form + el]: '',
                        [`RSD39` + dynamic?.form + el]: '',
                        [`LIC_NTS` + dynamic?.form + el]: '',
                    })
                    dynamic.addtFilds.push({
                        [`RSD34` + dynamic?.form + el]: false,
                        [`RSD34` + dynamic?.form + el + 'ErrMsg']: '',
                        [`STATE` + dynamic?.form + el]: false,
                        [`STATE` + dynamic?.form + el + 'ErrMsg']: '',
                        [`RSD36` + dynamic?.form + el]: false,
                        [`RSD36` + dynamic?.form + el + 'ErrMsg']: '',
                        [`FIN_ACT` + dynamic?.form + el]: false,
                        [`FIN_ACT` + dynamic?.form + el + 'ErrMsg']: '',
                        [`RSD39` + dynamic?.form + el]: false,
                        [`RSD39` + dynamic?.form + el + 'ErrMsg']: '',
                        [`LIC_NTS` + dynamic?.form + el]: false,
                        [`LIC_NTS` + dynamic?.form + el + 'ErrMsg']: '',
                    })
                })

                console.log('dynamic.addtObjs', dynamic.addtObjs)

                dynamic.addtObjsSchema = {}
                if (dynamic?.addtObjs?.length > 0) {
                    dynamic.addtObjs.forEach(async (el) => {
                        dynamic.addtObjsSchema = {
                            ...dynamic.addtObjsSchema,
                            ...el,
                        }
                    })
                }
                dynamic.addtFildsSchema = {}
                if (dynamic?.addtFilds?.length > 0) {
                    dynamic.addtFilds.forEach(async (el) => {
                        dynamic.addtFildsSchema = {
                            ...dynamic.addtFildsSchema,
                            ...el,
                        }
                    })
                }
                dynamic.addtObjsSchemaKeys = Object?.keys(
                    dynamic.addtObjsSchema
                )
                dynamic.addtFildsSchemaKeys = Object?.keys(
                    dynamic.addtFildsSchema
                )
                dynamic.addtSchema = {}
                if (dynamic?.addtObjsSchemaKeys?.length > 0) {
                    dynamic.addtObjsSchemaKeys.forEach(async (el) => {
                        if (el?.includes('RSD34')) {
                            dynamic.addtSchema = {
                                ...dynamic.addtSchema,
                                [el]: string()
                                    .min(0)
                                    .max(60)
                                    .required(
                                        'This field is required to be entered or selected.'
                                    ),
                            }
                        } else {
                            dynamic.addtSchema = {
                                ...dynamic.addtSchema,
                                [el]: string().required(
                                    'This field is required to be entered or selected.'
                                ),
                            }
                        }
                    })
                }
                dynamic.addtValid = {}
                if (dynamic?.addtFildsSchemaKeys?.length > 0) {
                    dynamic.addtFildsSchemaKeys.forEach(async (el) => {
                        if (el?.includes('ErrMsg')) {
                            dynamic.addtValid = {
                                ...dynamic.addtValid,
                                [el]: '',
                            }
                        } else {
                            dynamic.addtValid = {
                                ...dynamic.addtValid,
                                [el]: false,
                            }
                        }
                    })
                }
            }
            return dynamic
        } catch (error) {
            console.warn('Generate Schema Error:', error)
            return null
        }
    }

    // Validate Data Submission Against Schema
    const validation = async (digital_sub_name, submit) => {
        // Validate Form Submission Data Against Schema
        try {
            // Schema Object
            const schema = {}
            if (digital_sub_name === 'denied') {
                if (
                    formsData?.[digital_name]?.[digital_sub_name]?.values
                        ?.RSD82A === undefined ||
                    formsData?.[digital_name]?.[digital_sub_name]?.values
                        ?.RSD82A === 'N'
                ) {
                    schema.yup = object({
                        RSD82A: string().required(
                            'This field is required to be entered or selected.'
                        ),
                    })
                    schema.valid = {
                        RSD82A: false,
                        RSD82AErrMsg: '',
                    }
                } else if (
                    formsData?.[digital_name]?.[digital_sub_name]?.values
                        ?.RSD82A === 'Y' &&
                    formsData?.[digital_name]?.[digital_sub_name]?.auxiliary
                        ?.addtForms?.length === 0
                ) {
                    schema.yup = object({
                        RSD82A: string().required(
                            'This field is required to be entered or selected.'
                        ),
                        RSD34A: string()
                            .min(0)
                            .max(60)
                            .required(
                                'This field is required to be entered or selected.'
                            ),
                        STATEA: string().required(
                            'This field is required to be entered or selected.'
                        ),
                        RSD36A: string().required(
                            'This field is required to be entered or selected.'
                        ),
                        FIN_ACTA: string().required(
                            'This field is required to be entered or selected.'
                        ),
                        RSD39A: string().required(
                            'This field is required to be entered or selected.'
                        ),
                        LIC_NTSA: string().required(
                            'This field is required to be entered or selected.'
                        ),
                    })
                    schema.valid = {
                        RSD82A: false,
                        RSD82AErrMsg: '',
                        RSD34A: false,
                        RSD34AErrMsg: '',
                        RSD169A: false,
                        RSD169AErrMsg: '',
                        STATEA: false,
                        STATEAErrMsg: '',
                        RSD36A: false,
                        RSD36AErrMsg: '',
                        FIN_ACTA: false,
                        FIN_ACTAErrMsg: '',
                        RSD39A: false,
                        RSD39AErrMsg: '',
                        LIC_NTSA: false,
                        LIC_NTSAErrMsg: '',
                    }
                } else if (
                    formsData?.[digital_name]?.[digital_sub_name]?.values
                        ?.RSD82A === 'Y' &&
                    formsData?.[digital_name]?.[digital_sub_name]?.auxiliary
                        ?.addtForms?.length > 0
                ) {
                    const addtForms =
                        formsData[digital_name][digital_sub_name].auxiliary
                            .addtForms
                    const { addtSchema, addtValid } = await generateSchema(
                        digital_sub_name,
                        addtForms
                    )
                    schema.yup = object().shape({ ...addtSchema })
                    schema.valid = addtValid
                }
            } else if (digital_sub_name === 'action') {
                if (
                    formsData?.[digital_name]?.[digital_sub_name]?.values
                        ?.RSD82B === undefined ||
                    formsData?.[digital_name]?.[digital_sub_name]?.values
                        ?.RSD82B === 'N'
                ) {
                    schema.yup = object({
                        RSD82B: string().required(
                            'This field is required to be entered or selected.'
                        ),
                    })
                    schema.valid = {
                        RSD82B: false,
                        RSD82BErrMsg: '',
                    }
                } else if (
                    formsData?.[digital_name]?.[digital_sub_name]?.values
                        ?.RSD82B === 'Y' &&
                    formsData?.[digital_name]?.[digital_sub_name]?.auxiliary
                        ?.addtForms?.length === 0
                ) {
                    schema.yup = object({
                        RSD82B: string().required(
                            'This field is required to be entered or selected.'
                        ),
                        RSD34B: string()
                            .min(0)
                            .max(60)
                            .required(
                                'This field is required to be entered or selected.'
                            ),
                        STATEB: string().required(
                            'This field is required to be entered or selected.'
                        ),
                        RSD36B: string().required(
                            'This field is required to be entered or selected.'
                        ),
                        FIN_ACTB: string().required(
                            'This field is required to be entered or selected.'
                        ),
                        RSD39B: string().required(
                            'This field is required to be entered or selected.'
                        ),
                        LIC_NTSB: string().required(
                            'This field is required to be entered or selected.'
                        ),
                    })
                    schema.valid = {
                        RSD82B: false,
                        RSD82BErrMsg: '',
                        RSD34B: false,
                        RSD34BErrMsg: '',
                        RSD169B: false,
                        RSD169BErrMsg: '',
                        STATEB: false,
                        STATEBErrMsg: '',
                        RSD36B: false,
                        RSD36BErrMsg: '',
                        FIN_ACTB: false,
                        FIN_ACTBErrMsg: '',
                        RSD39B: false,
                        RSD39BErrMsg: '',
                        LIC_NTSB: false,
                        LIC_NTSBErrMsg: '',
                    }
                } else if (
                    formsData?.[digital_name]?.[digital_sub_name]?.values
                        ?.RSD82B === 'Y' &&
                    formsData?.[digital_name]?.[digital_sub_name]?.auxiliary
                        ?.addtForms?.length > 0
                ) {
                    const addtForms =
                        formsData[digital_name][digital_sub_name].auxiliary
                            .addtForms
                    const { addtSchema, addtValid } = await generateSchema(
                        digital_sub_name,
                        addtForms
                    )
                    schema.yup = object().shape({ ...addtSchema })
                    schema.valid = addtValid
                }
            } else if (digital_sub_name === 'surrendered') {
                if (
                    formsData?.[digital_name]?.[digital_sub_name]?.values
                        ?.RSD82C === undefined ||
                    formsData?.[digital_name]?.[digital_sub_name]?.values
                        ?.RSD82C === 'N'
                ) {
                    schema.yup = object({
                        RSD82C: string().required(
                            'This field is required to be entered or selected.'
                        ),
                    })
                    schema.valid = {
                        RSD82C: false,
                        RSD82CErrMsg: '',
                    }
                } else if (
                    formsData?.[digital_name]?.[digital_sub_name]?.values
                        ?.RSD82C === 'Y' &&
                    formsData?.[digital_name]?.[digital_sub_name]?.auxiliary
                        ?.addtForms?.length === 0
                ) {
                    schema.yup = object({
                        RSD82C: string().required(
                            'This field is required to be entered or selected.'
                        ),
                        RSD34C: string()
                            .min(0)
                            .max(60)
                            .required(
                                'This field is required to be entered or selected.'
                            ),
                        STATEC: string().required(
                            'This field is required to be entered or selected.'
                        ),
                        RSD36C: string().required(
                            'This field is required to be entered or selected.'
                        ),
                        FIN_ACTC: string().required(
                            'This field is required to be entered or selected.'
                        ),
                        RSD39C: string().required(
                            'This field is required to be entered or selected.'
                        ),
                        LIC_NTSC: string().required(
                            'This field is required to be entered or selected.'
                        ),
                    })
                    schema.valid = {
                        RSD82C: false,
                        RSD82CErrMsg: '',
                        RSD34C: false,
                        RSD34CErrMsg: '',
                        RSD169C: false,
                        RSD169CErrMsg: '',
                        STATEC: false,
                        STATECErrMsg: '',
                        RSD36C: false,
                        RSD36CErrMsg: '',
                        FIN_ACTC: false,
                        FIN_ACTCErrMsg: '',
                        RSD39C: false,
                        RSD39CErrMsg: '',
                        LIC_NTSC: false,
                        LIC_NTSCErrMsg: '',
                    }
                } else if (
                    formsData?.[digital_name]?.[digital_sub_name]?.values
                        ?.RSD82C === 'Y' &&
                    formsData?.[digital_name]?.[digital_sub_name]?.auxiliary
                        ?.addtForms?.length > 0
                ) {
                    const addtForms =
                        formsData[digital_name][digital_sub_name].auxiliary
                            .addtForms
                    const { addtSchema, addtValid } = await generateSchema(
                        digital_sub_name,
                        addtForms
                    )
                    schema.yup = object().shape({ ...addtSchema })
                    schema.valid = addtValid
                }
            } else if (digital_sub_name === 'pending') {
                if (
                    formsData?.[digital_name]?.[digital_sub_name]?.values
                        ?.RSD82D === undefined ||
                    formsData?.[digital_name]?.[digital_sub_name]?.values
                        ?.RSD82D === 'N'
                ) {
                    schema.yup = object({
                        RSD82D: string().required(
                            'This field is required to be entered or selected.'
                        ),
                    })
                    schema.valid = {
                        RSD82D: false,
                        RSD82DErrMsg: '',
                    }
                } else if (
                    formsData?.[digital_name]?.[digital_sub_name]?.values
                        ?.RSD82D === 'Y' &&
                    formsData?.[digital_name]?.[digital_sub_name]?.auxiliary
                        ?.addtForms?.length === 0
                ) {
                    schema.yup = object({
                        RSD82D: string().required(
                            'This field is required to be entered or selected.'
                        ),
                        RSD34D: string()
                            .min(0)
                            .max(60)
                            .required(
                                'This field is required to be entered or selected.'
                            ),
                        STATED: string().required(
                            'This field is required to be entered or selected.'
                        ),
                        RSD36D: string().required(
                            'This field is required to be entered or selected.'
                        ),
                        FIN_ACTD: string().required(
                            'This field is required to be entered or selected.'
                        ),
                        RSD39D: string().required(
                            'This field is required to be entered or selected.'
                        ),
                        LIC_NTSD: string().required(
                            'This field is required to be entered or selected.'
                        ),
                    })
                    schema.valid = {
                        RSD82D: false,
                        RSD82DErrMsg: '',
                        RSD34D: false,
                        RSD34DErrMsg: '',
                        RSD169D: false,
                        RSD169DErrMsg: '',
                        STATED: false,
                        STATEDErrMsg: '',
                        RSD36D: false,
                        RSD36DErrMsg: '',
                        FIN_ACTD: false,
                        FIN_ACTDErrMsg: '',
                        RSD39D: false,
                        RSD39DErrMsg: '',
                        LIC_NTSD: false,
                        LIC_NTSDErrMsg: '',
                    }
                } else if (
                    formsData?.[digital_name]?.[digital_sub_name]?.values
                        ?.RSD82D === 'Y' &&
                    formsData?.[digital_name]?.[digital_sub_name]?.auxiliary
                        ?.addtForms?.length > 0
                ) {
                    const addtForms =
                        formsData[digital_name][digital_sub_name].auxiliary
                            .addtForms
                    const { addtSchema, addtValid } = await generateSchema(
                        digital_sub_name,
                        addtForms
                    )
                    schema.yup = object().shape({ ...addtSchema })
                    schema.valid = addtValid
                }
            }
            await schema.yup.validate(
                { ...submit },
                { strict: true, abortEarly: false }
            )
            dispatch(
                updateSubFormValidity({
                    digital_name: digital_name,
                    digital_sub_name: digital_sub_name,
                    errors: {},
                })
            )
            return true
        } catch (err) {
            const errors = {}
            if (err?.inner?.length > 0) {
                await err.inner.forEach(async (el) => {
                    if (el?.path) {
                        errors[el?.path] = true
                        if (el?.errors?.length > 0) {
                            const errName = el?.path + 'ErrMsg'
                            const errMsg = el?.errors?.join(' ')
                            const tran = translateMultiFormField(
                                fields,
                                max_form_iterations,
                                el?.path
                            )
                            if (tran) {
                                const tranErrMsg = await errMsg.replaceAll(
                                    el?.path,
                                    tran
                                )
                                errors[errName] = tranErrMsg
                            } else {
                                errors[errName] = el?.errors?.join(' ')
                            }
                        }
                    }
                })
            }
            dispatch(
                updateSubFormValidity({
                    digital_name: digital_name,
                    digital_sub_name: digital_sub_name,
                    errors: errors,
                })
            )
            return false
        }
    }

    // Validate Form Submissions
    const validations = async (submit) => {
        try {
            // Check In Operation Object
            const promises = []

            if (sub_forms && submit) {
                if (sub_forms?.length > 0) {
                    sub_forms.forEach((el, i) => {
                        const name = el
                        const data = submit[i]
                        if (name && data) {
                            promises.push(validation(el, submit[i]))
                        }
                    })
                }
            }

            // Validate All Forms
            const validations = await Promise.all(promises)

            // Check For Validations
            if (validations) {
                return validations
            }
        } catch (error) {
            console.warn('Validations Error:', error)
            return null
        }
    }

    //////// Functional Methods

    // Handle Form Submission
    const handleSubmit = async () => {
        try {
            console.info('Discipline History: Submitted')

            setLoading(true)

            const submit = await extractSubmissionsForm(
                digital_name,
                formsData,
                sub_forms
            )

            const valid = await validations(submit)
            // Check If All Forms Are Validated
            if (valid?.length > 0) {
                // Check If All Form Data Is Valid
                const index = valid?.indexOf(false)
                if (index === -1) {
                    console.info('Discipline History: Passed Valid')

                    dispatch(
                        updateFormSystem({
                            digital_name: digital_name,
                            system: { valid: true },
                        })
                    )
                    setLoading(false)
                    setNotification({
                        type: 'inline',
                        visible: false,
                        kind: '',
                        title: '',
                        subtitle: '',
                    })

                    // Navigate To Next Form
                    navigate(submit_route ? submit_route : '/')
                } else {
                    console.info('Discipline History: Failed Valid')

                    dispatch(
                        updateFormSystem({
                            digital_name: digital_name,
                            system: { valid: false },
                        })
                    )
                    setLoading(false)
                    setNotification({
                        type: 'inline',
                        visible: true,
                        kind: 'error',
                        title: 'Form Errors:',
                        subtitle:
                            'There are errors on the form (such as missing required info). Please scroll up and update the fields with red messages.',
                    })

                    console.log(
                        'Discipline History Failed Valid: There are errors on the form (such as missing required info). Please scroll up and update the fields with red messages.'
                    )
                }
            }
        } catch (error) {
            console.warn('Handle Submit Error:', error)
            return null
        }
    }

    // Handle Keyboard Enter As Submit (Method)
    const handleKeyDown = async (event) => {
        try {
            if (event?.key === 'Enter') {
                await handleSubmit()
            }
        } catch (error) {
            console.warn('Handle Down Key Error:', error)
            return null
        }
    }
    //////// Memoization

    //////// Effects/Side Effects

    // Reload Watson Assistant Journey on Reload
    useEffect(() => {
        if (instance?.tours) {
            instance.tours.endTour()
            instance.tours.startTour(
                'Registered Nursing Endorsement Discipline History Tour'
            )
        }
        return () => {}
    }, [instance])

    //////////////// Render & Return

    if (loading) {
        return (
            <>
                <Form
                    tabIndex={0}
                    onKeyDown={handleKeyDown}
                    onSubmit={handleSubmit}
                >
                    <LoadingComponent />
                </Form>
            </>
        )
    } else {
        return (
            <>
                <Form
                    tabIndex={0}
                    onKeyDown={handleKeyDown}
                    onSubmit={handleSubmit}
                >
                    <DividerComponent text="Discipline (Denied)" />

                    <DisciplineHistoryDeniedForm
                        fields={fields}
                        instance={instance}
                    />

                    <DividerComponent text="Discipline (Disciplinary Action)" />

                    <DisciplineHistoryDisciplinaryActionForm
                        fields={fields}
                        instance={instance}
                    />

                    <DividerComponent text="Discipline (Surrendered)" />

                    <DisciplineHistorySurrenderedForm
                        fields={fields}
                        instance={instance}
                    />

                    <DividerComponent text="Discipline (Pending)" />

                    <DisciplineHistoryPendingForm
                        fields={fields}
                        instance={instance}
                    />
                </Form>

                <NotificationComponent notification={notification} />

                <div className="button-group">
                    <div className="button-group-item">
                        <ButtonComponent
                            click={handleSubmit}
                            title="Save Progress"
                        />
                    </div>
                </div>
            </>
        )
    }
}

export default DisciplineHistoryForm
